import { ActionIcon, useComputedColorScheme, useMantineColorScheme } from "@mantine/core";
import { IconMoonOutline18, IconSunOutline18 } from "nucleo-ui-outline-18";
import { useTranslation } from "react-i18next";

import { ICON_SIZE } from "@mountayaapp/theme";

/**
 * DocsThemeToggle is a single day/night button bound to Mantine's color-scheme
 * state. It reads the computed scheme (resolving the follow-system default to a
 * concrete light or dark) and flips to the opposite explicit mode on click, so
 * the header carries one compact control rather than a three-way auto/light/dark
 * switch. The glyph shows the mode the click moves to (a moon while light, a sun
 * while dark) and the aria-label names that action for assistive tech. The
 * computed value is resolved in an effect so the prerendered markup and the first
 * client render agree before the real preference refines it.
 */
export const DocsThemeToggle = () => {
  const { t } = useTranslation("docs");
  const { setColorScheme } = useMantineColorScheme();
  const computed = useComputedColorScheme("light", { getInitialValueInEffect: true });
  const isDark = computed === "dark";

  return (
    <ActionIcon
      aria-label={isDark ? t("theme.switchToLight") : t("theme.switchToDark")}
      color="gray"
      onClick={() => setColorScheme(isDark ? "light" : "dark")}
      size="lg"
      variant="subtle"
    >
      {isDark ? (
        <IconSunOutline18 size={ICON_SIZE.sm} />
      ) : (
        <IconMoonOutline18 size={ICON_SIZE.sm} />
      )}
    </ActionIcon>
  );
};
